// components/Footer.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../reducers/user'; // Import the logout action


import "./footer.css"
import image from "../images/Logo.svg"

const Footer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = sessionStorage.getItem('token');

  const handleLogout = () => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('role');
    dispatch(logout()); // Dispatch the logout action to clear the Redux store
    navigate('/login');
  };


  return (
    <footer>
      <div className="footer">
        <a href="https://www.prostatypegenomics.com/" target="_blank" rel="noopener noreferrer">
          <img src={image} alt="Prostatype Genomics Logo" width="96" height="41.904" />
        </a>

        <a href="mailto: info@prostatypegenomics.com">
          <h5>Contact</h5>
        </a>
        {token && (
          <button className="btn-logout" onClick={handleLogout} >
            Logout
          </button>
        )}
      </div>
    </footer>
  );
};

export default Footer;
